import { Components, Theme } from '@mui/material';

export const overrides: Components<Omit<Theme, 'components'>> = {
    MuiButton: {
        defaultProps: {
            size: 'small',
            disableRipple: true,
            variant: 'contained',
        },
        styleOverrides: {
            outlined: ({ theme }) => ({
                color: theme.palette.common.black,
            }),
            root: {
                width: '100%',
                height: '50px',
                borderRadius: '12px',
                textTransform: 'none',
                fontWeight: '700',
                color: 'white',
            },
        },
    },
    MuiLoadingButton: {
        defaultProps: {
            size: 'small',
            disableRipple: true,
            variant: 'contained',
        },
        styleOverrides: {
            root: {
                width: '100%',
                height: '50px',
                borderRadius: '12px',
                textTransform: 'none',
                fontWeight: '700',
                color: 'white',
            },
        },
    },
    MuiButtonGroup: {
        defaultProps: {
            size: 'small',
        },
    },
    MuiCheckbox: {
        defaultProps: {
            size: 'small',
        },
    },
    MuiFab: {
        defaultProps: {
            size: 'small',
        },
    },
    MuiFormControl: {
        defaultProps: {
            margin: 'dense',
            size: 'small',
        },
    },
    MuiFormHelperText: {
        defaultProps: {
            margin: 'dense',
        },
    },
    MuiIconButton: {
        defaultProps: {
            size: 'small',
        },
    },
    MuiInputBase: {
        defaultProps: {
            margin: 'dense',
        },
    },
    MuiInputLabel: {
        defaultProps: {
            margin: 'dense',
        },
    },
    MuiRadio: {
        defaultProps: {
            size: 'small',
        },
    },
    MuiSwitch: {
        defaultProps: {
            size: 'small',
        },
    },
    MuiTextField: {
        defaultProps: {
            margin: 'dense',
            size: 'medium',
            variant: 'outlined',
        },
        styleOverrides: {
            root: {
                '& .MuiOutlinedInput-root': {
                    borderRadius: '12px',
                },
            },
        },
    },
    MuiSelect: {
        defaultProps: {
            size: 'medium',
            MenuProps: {
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                },
            },
        },
        styleOverrides: {
            root: {
                borderRadius: '12px',
            },
        },
    },
    MuiAutocomplete: {
        styleOverrides: {
            root: {
                '& .MuiFormControl-root': {
                    margin: 0,
                },
            },
        },
    },
};
